import React from 'react';
import { motion } from 'framer-motion';

const Services = () => {
  const services = [
    { 
      num: "01", 
      title: "South Haven Transportation", 
      desc: "Reliable door-to-door service for the lighthouse, downtown, and North/South beaches. The local alternative to long Uber wait times." 
    },
    { 
      num: "02", 
      title: "LED Karaoke Van", 
      desc: "The ultimate LED party experience. Perfect for bachelorette parties and groups looking to sing their way through South Haven." 
    },
    { 
      num: "03", 
      title: "Winery & Brewery Rides", 
      desc: "Safe, dependable transit between South Haven's premier wineries and breweries. We handle the driving so you can enjoy the tasting." 
    }
  ];

  return (
    <section id="services" className="py-24 md:py-32 bg-primary text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 md:gap-12 mb-16 md:mb-24">
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-accent text-[0.65rem] md:text-xs tracking-[0.5em] uppercase font-bold mb-4 md:mb-6">Our Services</h2>
            <h3 className="text-4xl md:text-6xl lg:text-7xl font-serif">Transportation Services in <br /> <span className="italic">South Haven, MI.</span></h3>
          </motion.div>
          <motion.p 
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="text-white/50 font-light max-w-xs text-base md:text-lg font-serif italic"
          >
            Bespoke transportation for locals, visitors, and Lake Michigan shoreline celebrations.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-12 gap-y-12">
          {services.map((srv, idx) => (
            <motion.div 
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
              className="group"
            >
              <div className="flex items-baseline gap-4 md:gap-6 mb-4 md:mb-6">
                <span className="text-accent font-sans text-xs md:text-sm font-bold tracking-tighter">{srv.num}</span>
                <h4 className="text-2xl md:text-3xl font-serif group-hover:text-accent transition-colors duration-500">{srv.title}</h4>
              </div>
              <p className="text-white/60 font-light text-base leading-relaxed pl-8 md:pl-12 border-l border-white/10 group-hover:border-accent transition-colors duration-500">
                {srv.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;